import * as Yup from 'yup';
import { CommonMessages } from '../messages/validationMessages';


export const equipmentInfoSchema = Yup.object().shape({
    baynumber: Yup.number()
      .typeError(CommonMessages.equipmentnumber_required)
      .min(0, CommonMessages.equipmentnumber_required),
  
    bayName: Yup.string(),
  
    paystation: Yup.string()
      .required(CommonMessages.paystationbrand_required),
  
    internetconnectivity: Yup.number()
      .typeError(CommonMessages.internetconnectivity_required)
      .required(CommonMessages.internetconnectivity_required)
      .notOneOf([0], CommonMessages.internetconnectivity_required),
  
    equipmenttype: Yup.number()
      .typeError(CommonMessages.equipmenttype_required)
      .required(CommonMessages.equipmenttype_required)
      .notOneOf([0], CommonMessages.equipmenttype_required),

      // Only required if isPulse is true
  secPerPulse: Yup.number()
    //  .integer(CommonMessages.secperpulse_required)
    

    .when('isPulse', {
      is: true,
      then: (schema) =>
        schema
          .required(CommonMessages.secperpulse_required)
           .min(1, "Must be greater than 0")
          .typeError(CommonMessages.secperpulse_required),
      otherwise: (schema) => schema.notRequired()
    }),

  minPulsesToStart: Yup.number()
    // .integer(CommonMessages.only_integer_allowed)
     
    .when('isPulse', {
      is: true,
      then: (schema) =>
        schema
          .required(CommonMessages.minpulsestostart_required)
           .min(1, "Must be greater than 0")
          .typeError(CommonMessages.minpulsestostart_required),
      otherwise: (schema) => schema.notRequired()
    }),

  lprUsageType: Yup.number()
    .nullable()
    .when('isLpr', {
      is: true,
      then: (schema) =>
        schema
          .required(CommonMessages.lpr_usage_type_required)
          .notOneOf([0], CommonMessages.lpr_usage_type_required)
          .typeError(CommonMessages.lpr_usage_type_required),
      otherwise: (schema) => schema.nullable().notRequired(),
    }),

  washCategoryId: Yup.number()
    .nullable()
    .when('isComboWash', {
      is: true,
      then: (schema) =>
        schema
          .required(CommonMessages.category_required)
          .typeError(CommonMessages.category_required),
      otherwise: (schema) => schema.nullable().notRequired(),
    }),

  })
  .test(
    'baynumber-or-bayname-required',
    CommonMessages.baynumber_or_bayname_required,
    function (value) {
      if (!value) return false;
  
      const baynumberValid = typeof value.baynumber === 'number' && value.baynumber !== 0;
      const bayNameValid = typeof value.bayName === 'string' && value.bayName.trim() !== '';
  
      return baynumberValid || bayNameValid;
    }
  );